import React, { ReactNode } from "react";
import ReactDOM from "react-dom";
import ConteudoModel from "../model/ConteudoModel";
import NavegadorUtil from "../util/NavegadorUtil";
import AppState from "../model/AppState";
import NavegadorAcaoEnum from "../util/NavegadorAcaoEnum";
import Conteudo from "../Conteudo";

import { ReactComponent as ImagemCompartilhar } from "../assets/images/icons/compartilhar.svg";
import { ReactComponent as ImagemMenuPontos } from "../assets/images/icons/menu-pontos.svg";
import { ReactComponent as ImagemMenuFechar } from "../assets/images/icons/floating-menu-close.svg";

type RodapeConteudoContextoProps = {
  titulo?: string,
  conteudo: ConteudoModel,
  children?: ReactNode,
  parent: Conteudo
};

type RodapeConteudoContextoState = {
};

class RodapeConteudoContexto extends React.Component<RodapeConteudoContextoProps, RodapeConteudoContextoState> {

  constructor(props:RodapeConteudoContextoProps) {
    super(props);

    this.toggleMenu = this.toggleMenu.bind(this);
    this.hideMenu = this.hideMenu.bind(this);
    this.share = this.share.bind(this);
    this.curtir = this.curtir.bind(this);
  }

  toggleMenu(): any {
    const menuContextoJanela: any = ReactDOM.findDOMNode(this.refs.menuContextoJanela);
    if (menuContextoJanela.style.display === "none" || menuContextoJanela.style.display === "") {
      menuContextoJanela.style.display = "block";
    } else {
      menuContextoJanela.style.display = "none";
    }
  }

  hideMenu(): any {
    const menuContextoJanela: any = ReactDOM.findDOMNode(this.refs.menuContextoJanela);
    menuContextoJanela.style.display = "none";
  }

  share(): void {
    let titulo: string = "Oba Hortifruti";
    const { conteudo } = this.props;
    if (conteudo) {
      titulo = `${titulo} - ${conteudo.nome}`;
    }
    NavegadorUtil.share(titulo, "Vem conferir no Oba !", window.location.href);
  }

  curtir(conteudo: ConteudoModel): void {
    if (AppState.toggleCurtir(conteudo)) {
      NavegadorUtil.alerta(
        this,
        "Conteudo salvo em favoritos",
        conteudo.conteudoId,
        NavegadorAcaoEnum.NAV_UTIL_CONTEUDO_CURTIR,
        "Tirar"
      );
    } else {
      NavegadorUtil.alerta(
        this,
        "Conteudo removido de favoritos",
        conteudo.conteudoId,
        NavegadorAcaoEnum.NAV_UTIL_CONTEUDO_CURTIR,
        "Voltar"
      );
    }
    this.props.parent.forceUpdate();
  }

  render(): any {

    const { conteudo } = this.props;
    const foiCurtido: boolean = AppState.foiCurtido(conteudo);

    return (
      <>
        <footer className="context-menu-window" ref="menuContextoJanela" onClick={ this.hideMenu }>
          <div>
            <button onClick={ this.share } >
              <ImagemCompartilhar /> Compartilhar
            </button>
          </div>
          <div>
            { foiCurtido &&
            <button onClick={ () => this.curtir(conteudo) } className="tirar">
              <i className="icon fas fa-heart"></i>&nbsp;
              <span>Tirar em favoritos</span>
            </button>
            }
            { !foiCurtido &&
            <button onClick={ () => this.curtir(conteudo) }>
              <i className="icon far fa-heart"></i>&nbsp;
              Salvar em favoritos
            </button>
            }
          </div>
        </footer>
        <footer className="context-menu" ref="menuContexto" onClick={ this.toggleMenu }>
          <ImagemMenuPontos className="open" />
          <ImagemMenuFechar className="close" />
        </footer>
      </>
    );
  }
}

export default RodapeConteudoContexto;